import { ReactNode } from 'react';

import { useSelector } from 'react-redux';

import { buildStoredFileUrl } from '@/modules/humanChat/hooks/useAttachment';
import { selectSessionSource } from '@/modules/tryIt/redux/selectors';
import { ResponseMessage } from '@/shared/types/tryIt';

import { bubbleBrainClasses, responseClasses } from './constants';

type AudioMessage = Extract<ResponseMessage, { type: 'audio' }>;

interface AudioResponseProps {
  response: AudioMessage;
  icon: ReactNode;
}

export const AudioResponse = ({ response, icon }: AudioResponseProps) => {
  const source = useSelector(selectSessionSource);
  const fileUrl = buildStoredFileUrl(source, response.url);

  return (
    <div className={responseClasses}>
      {icon}
      <p className={bubbleBrainClasses}>
        <audio src={fileUrl} controls />
      </p>
    </div>
  );
};
